const RowSkeleton = () => (
    <div className="flex gap-4 items-center px-4 py-2 w-full rounded-2xl">
        <div className="w-1/4 h-4 rounded bg-white/15" />
        <div className="w-36 h-9 rounded-lg bg-white/15 shrink-0" />
        <div className="grow flex gap-4 items-center">
            <div className="grow h-3 rounded-full bg-white/15" />
            <div className="w-5 h-5 rounded bg-white/15 shrink-0" />
        </div>
    </div>
);

const CategorySkeleton = ({ rows }: { rows: number }) => (
    <div className="flex">
        <div className="w-8 flex items-center justify-center shrink-0">
            <div className="w-3 h-16 rounded bg-white/15" />
        </div>
        <div className="grow">
            {Array.from({ length: rows }).map((_, i) => (
                <RowSkeleton key={i} />
            ))}
        </div>
    </div>
);

export const ModifyBudgetSkeleton = () => (
    <div className="animate-pulse">
        <div className="flex justify-between items-center py-3 pr-2 pl-3">
            <div className="h-5 w-32 rounded bg-white/15" />
            <div className="h-9 w-20 rounded-lg bg-white/15" />
        </div>

        <CategorySkeleton rows={4} />
        <div className="h-1 bg-white/10 my-4 rounded-sm" />
        <CategorySkeleton rows={3} />
        <div className="h-1 bg-white/10 my-4 rounded-sm" />
        <CategorySkeleton rows={2} />

        <div className="h-10 w-28 mt-2 rounded-lg bg-white/15" />
    </div>
);
